export const isDeviceHavingUTCTimezone = () => {
  const timeZoneOffset = new Date().getTimezoneOffset();
  return !(timeZoneOffset);
};
